import { Suspense, type ComponentType } from "react";
import { lazyScreen } from "../../ui/lazyScreen";
import { usePortalReserve } from "../chat/TeamPage";

// Las pantallas de Configuración del Chat (T29–T31) y Estadísticas (T32) se cargan aparte para que la primera carga del
// portal quede dentro de su límite (size-limit en package.json). Mientras llega su código no se dibuja nada, como el resto
// de la pantalla mientras carga sus datos; ya cargadas se dibujan sin la espera de Suspense (ui/lazyScreen). La
// expresión de cada una es la dirección donde se usa: abierta directamente, su código se pide al arrancar.

function page<P extends object>(load: () => Promise<ComponentType<P>>, route: RegExp): ComponentType<P> {
  const Screen = lazyScreen(load, route);
  return function LazyPage(props: P) {
    // El espacio que el Dock (chat-app.js) reserva abajo para el botón «Chats», mientras el Dock no esté migrado (T24).
    usePortalReserve();
    return (
      <Suspense fallback={null}>
        <Screen {...props} />
      </Suspense>
    );
  };
}

export const ChatSettingsPage = page(
  () => import("./ChatSettingsPage").then((m) => m.ChatSettingsPage),
  /^\/portal\/(chat\/configuracion|configuracion\/chat)$/,
);
export const InboxesPage = page(
  () => import("./InboxesPage").then((m) => m.InboxesPage),
  /^\/portal\/bandejas(\/index)?$/,
);
export const RolesPage = page(
  () => import("./RolesPage").then((m) => m.RolesPage),
  /^\/portal\/chat\/configuracion\/roles(\/\d+)?$/,
);
export const InboxRoutingPage = page(
  () => import("./InboxRoutingPage").then((m) => m.InboxRoutingPage),
  /^\/portal\/chat\/configuracion\/bandejas\/\d+\/reparto$/,
);
export const ChannelRulesPage = page(
  () => import("./ChannelRulesPage").then((m) => m.ChannelRulesPage),
  /^\/portal\/canales(\/\d+)?\/reglas$/,
);
export const ChannelsPage = page(
  () => import("./ChannelsPage").then((m) => m.ChannelsPage),
  /^\/portal\/canales(\/index)?$/,
);
export const InboxDetailPage = page(
  () => import("./InboxDetailPage").then((m) => m.InboxDetailPage),
  /^\/portal\/bandejas\/(detalle|\d+)$/,
);
export const InboxNewPage = page(
  () => import("./InboxNewPage").then((m) => m.InboxNewPage),
  /^\/portal\/bandejas\/nueva$/,
);
export const WhatsappPage = page(
  () => import("./WhatsappPage").then((m) => m.WhatsappPage),
  /^\/portal\/canales\/whatsapp$/,
);
// Configuración de la empresa y Usuarios (2026-10-28).
export const SettingsPage = page(
  () => import("../settings/SettingsPage").then((m) => m.SettingsPage),
  /^\/portal\/configuracion(\/index)?$/,
);
export const UsersPage = page(
  () => import("../settings/UsersPage").then((m) => m.UsersPage),
  /^\/portal\/configuracion\/usuarios$/,
);
export const UserNewPage = page(
  () => import("../settings/UserNewPage").then((m) => m.UserNewPage),
  /^\/portal\/configuracion\/usuarios\/nuevo$/,
);
export const StatisticsPage = page(
  () => import("../../statistics/StatisticsPage").then((m) => m.StatisticsPage),
  /^\/portal\/chat\/estadisticas$/,
);
